import { render } from "./TuDoudb.vue?vue&type=template&id=786fed05&scoped=true"
import script from "./TuDoudb.vue?vue&type=script&lang=js"
export * from "./TuDoudb.vue?vue&type=script&lang=js"

import "./TuDoudb.vue?vue&type=style&index=0&id=786fed05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786fed05"]])

export default __exports__